export default "__VITE_ASSET__DLDrK$lV__"